import { createSvgIcon } from '@mui/material/utils'

export const CoinbaseWalletIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 146 146">
    <rect width="146" height="146" fill="#0052FF" rx="73" ry="73"></rect>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9 73C21.9 102.053 45.1466 125.3 74.2 125.3C103.253 125.3 126.5 102.053 126.5 73C126.5 43.9466 103.253 20.7 74.2 20.7C45.1466 20.7 21.9 43.9466 21.9 73ZM60.5 54.75C58.5673 54.75 57 56.3173 57 58.25V87.75C57 89.6827 58.5673 91.25 60.5 91.25H87.9C89.8327 91.25 91.4 89.6827 91.4 87.75V58.25C91.4 56.3173 89.8327 54.75 87.9 54.75H60.5Z"
      fill="white"
    ></path>
  </svg>,
  'CoinbaseWallet',
)
